import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class HeroText extends Component {
  constructor(obj) {
    super(obj)

    this.referenceImage = qs(".reference", this.el)

    this.expand = this.referenceImage.getAttribute("data-expand")

    const sticky = qs(".sticky", this.el)
    const stickyContent = qs(".sticky-content", this.el)

    this.animate()

    if (this.expand === "true") {
      this.timeline = gsap.timeline({ paused: true })

      this.sticky = new Sticky({
        el: sticky,
        sticky: stickyContent,
        isSmooth: store.flags.isSmooth,
        onUpdateCallback: self => {
          this.timeline.progress(self.progress)
        },
      })

      this.sticky.resize()

      this.expandImageAnimation()
    } else {
      sticky.classList.add("non-sticky")
    }
  }

  on() {
    window.addEventListener("resize", this.onResize)
  }

  off() {
    window.removeEventListener("resize", this.onResize)
  }

  animate() {
    const infos = qs(".phone-email", this.el)
    const desc = qs(".bottom", this.el)
    const reference = qs(".reference", this.el)
    const email = qs(".email", this.el)
    const phone = qs(".phone", this.el)

    gsap.from(reference, {
      autoAlpha: 0,
      // y: 50,
      duration: 1.2,
    })

    gsap.fromTo(desc, { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: 1.2, overwrite: "auto" })

    if (email) {
      gsap.from(email, {
        autoAlpha: 0,
        y: 50,
        duration: 1.2,
      })
    }

    if (phone) {
      gsap.from(phone, {
        autoAlpha: 0,
        y: 50,
        duration: 1.2,
      })
    }

    if (infos) {
      gsap.from(infos, {
        autoAlpha: 0,
        y: 50,
        duration: 1.2,
      })
    }
  }

  expandImageAnimation() {
    if (this.timeline) this.timeline.kill()

    const reference = qs(".reference", this.el)
    const desc = qs(".bottom", this.el)
    const placeholder = qs(".fullscreen-placeholder", this.el)
    const email = qs(".email", this.el)
    const phone = qs(".phone", this.el)
    const infos = qs(".phone-email", this.el)

    const p = bounds(placeholder)
    const r = bounds(reference)

    // exact center-to-center translation (viewport coords)
    const deltaX = p.left + p.width / 2 - (r.left + r.width / 2)
    const deltaY = p.top + p.height / 2 - (r.top + r.height / 2)

    // cover scale (or Math.min for contain)
    const scale = Math.max(p.width / r.width, p.height / r.height)

    // set pixel-perfect transform-origin (avoids % rounding issues)
    gsap.set(reference, {
      transformOrigin: `${r.width / 2}px ${r.height / 2}px`,
    })

    this.timeline = gsap.timeline({ paused: true })
    this.timeline.fromTo(desc, { opacity: 1, y: 0 }, { opacity: 0, y: 40, ease: "none", overwrite: "auto" })
    if (email) {
      this.timeline.fromTo(email, { opacity: 1, y: 0 }, { opacity: 0, y: 40, ease: "none", overwrite: "auto" }, "<")
    }
    if (phone) {
      this.timeline.fromTo(phone, { opacity: 1, y: 0 }, { opacity: 0, y: 40, ease: "none", overwrite: "auto" }, "<")
    }
    if (infos) {
      this.timeline.fromTo(infos, { opacity: 1, y: 0 }, { opacity: 0, y: 40, ease: "none", overwrite: "auto" }, "<")
    }
    this.timeline.to(
      reference,
      {
        x: deltaX, // absolute (not "+=")
        y: deltaY,
        scale,
        ease: "none",
        duration: 1.2,
      },
      0.3
    )
  }

  resize() {
    if (this.expand === "true") {
      this.sticky.resize()

      this.expandImageAnimation()
    }
  }
}
